import { render } from "./ProfileLayout.vue?vue&type=template&id=63726ef6"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"
script.render = render

export default script